import { useEffect } from "react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import useConnectWithX from "@/hooks/useConnectWithX";
import { useAuthStore } from "@/hooks/useAuthStore";
import { trackEvent } from "@/utils/analytics";
import { EventAction } from "@/types/analytics";
import { getXDaoHomePath } from "@/lib/utils";

export default function Login() {
  const [location, setLocation] = useLocation();
  const { isAuthenticated } = useAuthStore();
  const connectWithX = useConnectWithX().connectWithX;

  // Extract redirect parameter from URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectPath = urlParams.get("redirect");

  // If user is already authenticated, redirect them to their intended destination
  useEffect(() => {
    if (isAuthenticated) {
      setLocation(redirectPath || getXDaoHomePath());
    }
  }, [isAuthenticated, redirectPath, setLocation]);

  const handleLogin = async () => {
    trackEvent('ui_interaction', EventAction.BUTTON_CLICK, {
      label: 'login_connect_x',
      component: 'login_page',
      location: 'connect_button',
      button_type: 'primary',
    });
    // Store the intended redirect path in sessionStorage
    // This will be used by OAuthCallback after successful authentication
    if (redirectPath) {
      sessionStorage.setItem("redirectAfterLogin", redirectPath);
    }

    // Initiate OAuth flow
    await connectWithX();
  };

  // Don't render the login UI if already authenticated
  if (isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
      <main className="flex-grow">
        <div className="h-full flex flex-col items-center justify-center px-4 py-12 md:py-20">
          <div className="mb-8">
            <Logo size="lg" />
          </div>

          <p className="text-center max-w-lg mb-10 text-lg text-gray-300">
            Tweetonium is the Next Frontier of Decentralized Asset Ownership through an NFT-powered DAO with Performance-Backed Equity Derivatives.
          </p>

          <Button
            variant="outline"
            size="lg"
            className="rounded-full border-2 border-white px-6 py-6 text-lg font-medium hover:bg-white hover:text-black"
            onClick={handleLogin}
          >
            Connect X (Twitter) Account
          </Button>
        </div>
      </main>
    </div>
  );
}
